<icds-data-list
	class="grid-cols-[auto_1fr] gap-x-4"
	dataItemStyle="card"
	[dataGetItemKey]="getRestrictiveMeasureKey"
	[dataItems]="dataRestrictiveMeasures()"
>
	<ng-template let-restrictiveMeasure [icdsDataListItemTemplate]="dataRestrictiveMeasures()">
		<article class="col-span-2 grid grid-cols-subgrid p-2 gap-y-1">
			<header class="col-span-2 flex justify-between items-baseline">
				<span class="font-semibold wrap-break-word">{{
					evaluationMeasureConceptToDisplay()(restrictiveMeasure.measure)
				}}</span>
				<ic-evaluation-measure-status-tag
					class="justify-self-end"
					[dataEvaluationMeasure]="restrictiveMeasure.measure"
				/>
			</header>
			<dl class="col-span-2 grid grid-cols-subgrid gap-y-1">
				<div class="col-span-2 grid grid-cols-subgrid mb-0!" icdsDi>
					<dt class="mb-0!" icdsDt>{{ "domain-model.evaluationMeasure.property.details.label" | translate }}</dt>
					<dd icdsDd>{{ restrictiveMeasure.measure.details ?? "-" }}</dd>
				</div>
				@if (restrictiveMeasure.measure.reason; as measureReason) {
					<div class="col-span-2 grid grid-cols-subgrid mb-0! mt-1" icdsDi>
						<dt class="mb-0!" icdsDt>
							{{ "domain-model.evaluationMeasureRestriction.property.reason.label" | translate }}
						</dt>
						<dd icdsDd>{{ measureReason }}</dd>
					</div>
				}
				<div class="col-span-2 grid grid-cols-subgrid mb-0! mt-1" icdsDi>
					<dt class="mb-0!" icdsDt>{{ "domain-model.evaluationMeasure.property.followUpPlan.label" | translate }}</dt>
					<dd icdsDd>{{ restrictiveMeasure.followUpPlan.title }}</dd>
				</div>
				@if (restrictiveMeasure.evaluation.evaluationDate; as evaluationDate) {
					<div class="col-span-2 grid grid-cols-subgrid mb-0! mt-1" icdsDi>
						<dt class="mb-0!" icdsDt>
							{{ "domain-model.evaluationMeasure.property.evaluationDate.label" | translate }}
						</dt>
						<dd icdsDd>{{ evaluationDate | date: "shortDate" }}</dd>
					</div>
				}
			</dl>
		</article>
	</ng-template>
	<ng-template icdsDataListEmptyTemplate>
		<icds-empty-feedback [dataFeedback]="'domain-model.evaluationMeasureRestriction.list.emptyData' | translate" />
	</ng-template>
</icds-data-list>
